import { FC } from 'react';
import { img } from '@/helpers/utils';
import FingerUpIcon from '@/assets/svg/ico_finger_up.svg?react';
import Button from '@/components/controls/Button/Button.component';
import ModalSheet from '@/components/interactive/ModalSheet/ModalSheet.component';
import {
    IMAGE_GUID,
    PHOTO_ADVICES,
} from '@/components/widgets/AddPhotoWidget/FullTipsBottomSheet/FullTipsBottomSheet.config';
import styles from '@/components/widgets/AddPhotoWidget/FullTipsBottomSheet/FullTipsBottomSheet.module.scss';
import { FullTipsBottomSheetPropsIF } from '@/components/widgets/AddPhotoWidget/FullTipsBottomSheet/FullTipsBottomSheet.types';

const FullTipsBottomSheet: FC<FullTipsBottomSheetPropsIF> = ({ onClose }) => (
    <ModalSheet
        onClose={onClose}
        dataTest="full_tips_bottom_sheet"
        bottomSheetMobile
        classNameBody="flcol"
    >
        <div className={`flcol ${styles.headerBlock}`}>
            <h2 className={styles.headerTitle}>Подробнее о требованиях</h2>
            <p className={styles.headerSubtitle}>
                Чтобы сделать идеальное фото изделия для гардероба
            </p>
        </div>
        <div
            className={`bgc ${styles.image}`}
            style={{
                backgroundImage: `url(${img(IMAGE_GUID)})`,
            }}
        >
            <div className={`flc ${styles.icon}`}>
                <FingerUpIcon />
            </div>
        </div>
        <div className={`flcol ${styles.photoAdvicesWrapper}`}>
            {PHOTO_ADVICES.map((section) => (
                <div
                    key={section.title}
                    className={`flcol ${styles.photoAdviceBlock}`}
                >
                    <h3 className={styles.photoAdviceTitle}>{section.title}</h3>
                    <ul className={`flcol ${styles.photoAdviceList}`}>
                        {section.items.map(({ subtitle, description }) => (
                            <li key={subtitle}>
                                <span>{subtitle}</span> {description}
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
        <Button
            className={styles.sourceButton}
            clickHandler={onClose}
            dataTest="close_full_tips_bottom_sheet"
        >
            Понятно
        </Button>
    </ModalSheet>
);

export default FullTipsBottomSheet;
